import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Svg from "../../../assets/Svgs/Svg";
import styled from "styled-components";
import { data } from "../../../Data/data";
import useMediaQuery from "../../../hooks/useMediaQuery";
import Animation from "../../../animations/Animation";

const StyleWrapper = styled.div`
   .scrollable {
      width: 100%;
      overflow: hidden;
   }

   @media (min-width: 1366px) {
      .scrollable-container {
         margin-bottom: 100px;
         padding-bottom: 100px;
      }
   }
   @media (max-width: 1366px) {
      .workDotContainer {
         margin-top: 68px;
      }
   }

   .dot {
      cursor: pointer;
      position: relative;
      z-index: 10 !important;
   }

   .circle-mobile {
      width: 328px;
      height: 328px;
      background-color: transparent;
      border-radius: 50%;
      position: relative;
      display: flex;
      align-items: center;
      top: -73px;
      left: 4px;
      color: #f5f5f5;
      transition: all 400ms;
      .number {
         fill: #ffffff;
         opacity: 5%;
         transition: all 400ms;
      }
   }
   .circle-mobile:hover {
      background: white;
      color: black;
      cursor: pointer;
      .number {
         fill: #ff5101;
         opacity: 100%;
         transition: all 400ms;
      }
   }
   .circle {
      width: 400px;
      height: 400px;
      background-color: transparent;
      border-radius: 50%;
      position: relative;
      display: flex;
      align-items: center;
      top: -67px;
      left: -51px;
      color: #f5f5f5;
      transition: all 400ms;
      z-index: 9 !important; //0
      .number {
         fill: #ffffff;
         opacity: 5%;
         transition: all 400ms;
      }
   }

   .circle:hover {
      background: white;
      color: black;
      cursor: pointer;
      .number {
         fill: #ff5101;
         opacity: 100%;
         transition: all 400ms;
      }
   }

   .z-1 {
      z-index: 1 !important;
      position: relative;
   }
   .sm-number {
      position: absolute;
      z-index: 1;
      top: -9px;
      right: -30px;
   }
`;

const HowItWorks = () => {
   const lgBreakpoint = useMediaQuery("(min-width: 1366px)");
   return (
      <StyleWrapper>
         <section className="bgBlack pt60 pb100 mb80 mobPt50 mobPb50 mobMb10 howitworks scrollable">
            <div>
               <Container className="scrollable-container">
                  <Row>
                     <Col sx={12}>
                        <Animation fade bottom>
                           <div className="workStroke position-relative mt-5">
                              <Animation fade bottom>
                                 <span className="red-bar colorWhite">THE JOURNEY</span>
                                 <h2 className="fBold tabHeadingFontSize mobSubTitle colorWhite mt15">
                                    Witmates Technologies <br />A Journey of Growth
                                    <br /> and Excellence
                                 </h2>
                              </Animation>
                              {lgBreakpoint ? (
                                 <>
                                    <div className="mainstroke">
                                       <div className="workStroke">{Svg.workStroke}</div>
                                    </div>{" "}
                                 </>
                              ) : (
                                 <>
                                    <div
                                       style={{
                                          background: "#ff5101",
                                          width: "4px",
                                          height: `calc(80%)`,
                                          position: "absolute",
                                          top: "13%",
                                          left: "25px",
                                          zIndex: "1",
                                       }}></div>
                                 </>
                              )}
                              <div className="workDotContainer">
                                 {data?.journeyList?.map((time, index) => (
                                    <div key={index} className={`workDot ${lgBreakpoint ? "position-absolute" : ""}`}>
                                       <div className="position-relative">
                                          <div className="dot">{Svg.workDot}</div>
                                          <div className={`${lgBreakpoint ? "circle" : "circle-mobile"} p-5`} style={{ zIndex: "0" }}>
                                             <div className="row align-items-end justify-content-center p-3 hover-container">
                                                <div className="col-12 col-md-12 col-lg-12 col-xl-7 text-start">
                                                   <b>{time.title}</b>
                                                </div>
                                                <div className={`col-5 d-flex justify-content-start ${lgBreakpoint ? "" : "sm-number"}`}>{time.svg}</div>
                                                <div className="col-12 mt-3">
                                                   {time.description.map((line, idx) => (
                                                      <div className="d-flex" key={idx}>
                                                         <span>●</span>
                                                         <span key={`newLine-${idx}`} className="d-block font-lg-14 font-16 font14">
                                                            &nbsp;{line}
                                                         </span>
                                                      </div>
                                                   ))}
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 ))}
                              </div>
                           </div>
                        </Animation>
                     </Col>
                  </Row>
               </Container>
            </div>
         </section>
      </StyleWrapper>
   );
};

export default HowItWorks;
